// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__23C5z","upload":"Small_upload__29Sdj","imageWrap":"Small_imageWrap__L831y","removeBtn":"Small_removeBtn__3tUpA"};